import { PERSONAL_SCREEN_NAME } from '@/common/screenNames'

const TheContainer = () => import('@/containers/TheContainer')
const PersonalSettings = () => import('@/views/account/PersonalSettings')

/** F5・直リンクより前に本人用個人設定ルートを登録する。 */
export default function registerPersonalSettingsRoutes (router) {
  router.addRoutes([
    {
      path: '/my',
      component: TheContainer,
      children: [
        {
          path: 'settings',
          name: PERSONAL_SCREEN_NAME,
          component: PersonalSettings,
          meta: { requiresAuth: true, personalSettings: true }
        }
      ]
    }
  ])
}
